import { urlParam } from "./helper";

Cm.post = {
    init: function() {
        const uri = $('.filter__post select').data('uri');
        $('.filter__post select').off('change').on('change', function() {
            var p = ( urlParam('page') !== null ? '&page=' + urlParam('page') : '' );
            window.location = (wp.archive_url || uri) + ( this.value.toLowerCase() != 'all' ? '/?q=' + this.value.replace(/-/g, ' ') : '' );
        });

        if (window.location.href.indexOf('/journal/camden-market-summer-sale') > -1) {
            window.location.href = '/sale/camden-market-summer-sale';
        }
    }
};